import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import withStyles from '@mui/styles/withStyles';
import { RAKUNA_COLOR } from '../../shared/Constants';

const styles = {
  root: {
    '&$checked': {
      color: RAKUNA_COLOR,
    },
  },
  checked: {},
};

const CheckboxInput = (props) => {
  const {
    classes, label, checked, onChange, ...rest
  } = props;
  return (
    <FormControlLabel
      control={(
        <Checkbox
          checked={checked}
          onChange={onChange}
          {...rest}
          classes={{
            root: classes.root,
            checked: classes.checked,
          }}
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
        />
      )}
      label={label}
    />
  );
};

CheckboxInput.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.instanceOf(Object).isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

CheckboxInput.defaultProps = {
  checked: false,
  onChange: null,
};

export default withStyles(styles)(CheckboxInput);
